module.exports = __webpack_public_path__ + "static/media/choose-name.8dee6a18.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/baby-info/choose-name.png
// module id = 497
// module chunks = 1